import { ToastProgrammatic } from '@akerolabs/akero-vue/src/components/toast'
let campaignRoles = [
  { value: 'akero', label: 'Akero' },
  { value: 'media_buying', label: 'Media Buying' },
  { value: 'paid_media', label: 'Paid Media' },
  { value: 'planning', label: 'Planning' },
  { value: 'programmatic', label: 'Programmatic / Ad Ops' },
  { value: 'digital_consultant', label: 'Digital Consultant' },
  { value: 'copywriting', label: 'Copywriting' },
  { value: 'creative_development', label: 'Creative Development' },
  { value: 'creative_freelancer', label: 'Creative Freelancer' },
  { value: 'creative_strategy', label: 'Creative Strategy' },
  { value: 'design', label: 'Design' },
  { value: 'bids', label: 'Bids' },
  { value: 'finance', label: 'Finance' },
  { value: 'human_resources', label: 'Human Resources / Recruitment' },
  { value: 'office_management', label: 'Office Management' },
  { value: 'project_management', label: 'Project Management' },
  { value: 'resourcing', label: 'Resourcing' },
  { value: 'systems', label: 'Systems / IT' },
  { value: 'research', label: 'Research' },
  { value: 'account_management', label: 'Account Management' },
  { value: 'business_development', label: 'Business Development' },
  { value: 'marketing', label: 'Marketing' },
  { value: 'business_intelligence', label: 'Business Intelligence' },
  { value: 'consultancy', label: 'Consultancy' },
  { value: 'data_science', label: 'Data Science' },
  { value: 'quality_assurance', label: 'Quality Assurance / Testing' },
  { value: 'software_development', label: 'Software Development' },
  { value: 'support', label: 'Support' },
  { value: 'web_analysis', label: 'Web Analysis' },
  { value: 'account_director', label: 'Account Director' },
].sort((a, b) => {
  return a.label > b.label
})

import {
  display as canDisplay,
  userLevelIsHigerThan,
} from '@akerolabs/akero-vue/src/services/users.js'

export function success(message) {
  ToastProgrammatic.open({
    message,
    type: 'success',
  })
}

export function error(message, exception = null) {
  ToastProgrammatic.open({
    message,
    type: 'danger',
  })
  if (exception) {
    console.log(exception)
  }
}

export function userHigherThan(userLevel) {
  return userLevelIsHigerThan(userLevel)
}

export function display(type, levels) {
  return canDisplay(type, levels)
}

export function itemClasses({ archived }) {
  const classes = []
  if (archived) {
    classes.push('is-archived')
  }
  return classes
}

export function findCampaignRole(value) {
  return campaignRoles.find((r) => r.value === value).label
}

export { campaignRoles }
